import React, { FC } from "react";
import { Button, Col, Drawer } from "antd";
import { useDrawerStore } from "~/stores/drawerStore";
import { BaseText } from "~/components";
import { COLORS } from "~/common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark, faXmark } from "@fortawesome/free-solid-svg-icons";

interface BaseDrawerProps {
  extra?: React.ReactNode;
  bodyStyle?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  footerStyle?: React.CSSProperties;
  footer?: React.ReactNode;
}

const BaseDrawer: FC<BaseDrawerProps> = ({
  extra,
  bodyStyle,
  headerStyle,
  footerStyle,
  footer,
}) => {
  const {
    isOpen,
    title,
    description,
    children,
    width,
    placement,
    closable,
    maskClosable,
    closeDrawer,
  } = useDrawerStore();

  return (
    <Drawer
      title={
        title ? (
          <Col style={{ display: "flex", flexDirection: "column" }}>
            <BaseText variant="h5" weight="semibold">
              {title}
            </BaseText>
            <BaseText variant="body2" color="textSecondary">
              {description}
            </BaseText>
          </Col>
        ) : undefined
      }
      placement={placement}
      closable={closable}
      maskClosable={maskClosable}
      onClose={closeDrawer}
      open={isOpen}
      width={width}
      extra={extra}
      closeIcon={
        <Button
          style={{
            backgroundColor: COLORS.PRIMARY,
            borderRadius: 10,
            width: 40,
            height: 40,
            marginLeft: -15,
          }}
        >
          <FontAwesomeIcon icon={faXmark} color={COLORS.WHITE} />
        </Button>
      }
      styles={{
        body: {
          padding: "15px",
          ...bodyStyle,
        },
        header: {
          borderBottom: "1px solid " + COLORS.BORDER,
          ...headerStyle,
        },
        footer: {
          ...footerStyle,
        },
      }}
      footer={footer}
    >
      {children}
    </Drawer>
  );
};

export default BaseDrawer;
